import { useEffect, useState } from "react";
import {
	LoginScreenNavigationProp,
	routeLogin,
	ProfileNameSelectScreenNavigationProp,
	routeProfileNameSelect,
	RecoverPasswordScreenNavigationProp,
	routeRecoverPassword,
	HomeScreenNavigationProp,
	routeHome,
	routePrivacyPolicy,
} from "../../Routes";
import { AsyncStorageKeys, Icon, Pages, ProfileNameState } from "../../Types";
import { useNavigation } from "@react-navigation/native";
import { globalAny, capitalize, login, pushProfileNameStateToBrowserHistory, validateEmail, generateDeviceInfo, hasValue } from "../../utils/Utils";
import { light_black } from "../../StyleHelpers";
import TouchableButton from "../../components/TouchableButton";
import ComponentThemeType from "../../models/ComponentTheme";
import ComponentTypeEnum from "../../models/ComponentTypeEnum";
import TextInput from "../../components/TextInput";
import AsyncStorage from "@react-native-async-storage/async-storage";
import TopAppBar from "../../components/TopAppBar";
import Toast from "../../components/Toast";
import useGenericContentStore from "../../store/genericContent.store";
import closeIcon from "../../assets/TopNavBarIcon/icon_nav_close.svg";
import backIcon from "../../assets/TopNavBarIcon/icon_nav_back.svg";
import { SafeAreaView } from "react-native";
import SignInLoader from "../../components/Loaders/SignInLoader";
import useLoginStore from "../../store/useLogin.store";
import useSessionStore from "../../store/useSession.store";
import { getPresignedUrl } from "../../networking/networking";
import useMqttStore from "../../store/useMqtt.store";
import PrivacyPolicyButton from "../../components/PrivacyPolicyButton";
import {
	StyledButtonContainer,
	StyledButtonMainContainer,
	StyledFormContainer,
	StyledWrapper,
	StyledNarrowButtonsContainer,
	StyledNarrowButtonsWrapper,
	StyledNarrowTextInput,
	StyledNarrowTextContainer,
} from "./styled";
import { RetryCommand } from "../../enums/RetryCommand";
import useRetryCommand from "../../hooks/userRetryCommand";
import NarrowScreenContainer from "../../components/Layout/NarrowScreenContainer";
import useToggleStore from "../../store/useToggle.store";

const SignInScreen = () => {
	const navigationLoginScreen = useNavigation<LoginScreenNavigationProp>();
	const navigationHomeScreen = useNavigation<HomeScreenNavigationProp>();
	const navigationProfileNameSelectScreen = useNavigation<ProfileNameSelectScreenNavigationProp>();
	const navigationRecoverPasswordScreen = useNavigation<RecoverPasswordScreenNavigationProp>();
	const navigation = useNavigation<any>();
	const [email, setEmail] = useState("");
	const [password, setPassword] = useState("");
	const [emailError, setEmailError] = useState(false);
	const [emailMessage, setEmailMessage] = useState("");
	const [passwordError, setPasswordError] = useState(false);
	const [passwordMessage, setPasswordMessage] = useState("");
	const [signInLoading, setSignInLoading] = useState(false);
	const [secureTextEntry, setSecureTextEntry] = useState(true);
	const [visible, setVisible] = useState(false);
	const [toastMessage, setToastMessage] = useState("");
	const [labelText, setLabelText] = useState<any>();
	const [autoFocusPass, setAutoFocusPass] = useState(false);
	const { isNarrow } = useGenericContentStore((state) => ({ isNarrow: state.isNarrow }));
	const mistakeCount = useGenericContentStore((state: any) => state.mistakeCount);
	const setMistakeCount = useGenericContentStore((state: any) => state.setMistakeCount);
	const setIsLogin = useGenericContentStore((state: any) => state.setIsLogin);
	const setLoginEmail = useGenericContentStore((state: any) => state.setLoginEmail);
	const onDismissSnackBar = () => setVisible(false);
	const setIsLoggedIn = useLoginStore((state: any) => state.setIsLoggedIn);
	const isLoggedIn = useLoginStore((state: any) => state.isLoggedIn);
	const isSigninLoading = useSessionStore((state: any) => state.isSigninLoading);
	const setIsSigninLoading = useSessionStore((state: any) => state.setIsSigninLoading);
	const setPresignedUrl = useMqttStore((state: any) => state.setPresignedUrl);
	const setDeviceInfo = useMqttStore((state: any) => state.setDeviceInfo);
	const setNavigateEvent = useGenericContentStore((state: any) => state.setNavigateEvent);
	const setRetryCommand = useGenericContentStore((state: any) => state.setRetryCommand);
	const isScreenSelection = useToggleStore((state: any) => state.isScreenSelection);

	const onPressEye = () => {
		if (secureTextEntry) {
			setSecureTextEntry(false);
			return;
		}
		setSecureTextEntry(true);
	};

	const onBackPress = () => {
		//@ts-ignore
		navigationLoginScreen.navigate(routeLogin);
	};

	const onEnterEmail = (emailValue: any) => {
		if (!emailValue) {
			setEmailError(false);

			return false;
		}

		if (validateEmail(emailValue)) {
			setEmailError(false);

			return true;
		}

		setEmailMessage(globalAny.language.invalid_email);
		setEmailError(true);
		return false;
	};

	const onEnterPassword = (passwordValue: any) => {
		if (passwordValue.length > 0) {
			setPasswordError(false);
			return true;
		}

		setPasswordMessage(globalAny.language.invalid_password);
		setPasswordError(true);
		return false;
	};

	const onErrorSignIn = (response: any) => {
		setIsSigninLoading(false);
		setLabelText("");
		setToastMessage(response);
		setVisible(true);
		setAutoFocusPass(false);
		setMistakeCount(mistakeCount + 1);
	};

	const RecoverPassword = () => {
		navigationRecoverPasswordScreen.navigate(routeRecoverPassword, { settings: "recover" });
	};

	const validateMistakeCount = () => {
		setLabelText(globalAny.language.label_retry);
		if (mistakeCount > 2) {
			const allowUntil = new Date().setMinutes(new Date().getMinutes() + 1);
			AsyncStorage.setItem(AsyncStorageKeys.allowUntil, allowUntil.toString());
			setLabelText(null);
			setToastMessage(globalAny.language.maximum_attempt);
			setEmail("");
		}
	};

	const setProfileName = async (deviceInfo: any) => {
		await AsyncStorage.setItem(AsyncStorageKeys.deviceId, deviceInfo.deviceId);
		globalAny.profileName = deviceInfo.deviceName;
	};

	const updateDevice = (profileName: any) => {
		const deviceInfo = generateDeviceInfo(profileName);
		setDeviceInfo(deviceInfo);
		setProfileName(deviceInfo);
	};

	const validateDeviceScreen = () => {
		if (!isScreenSelection) {
			const profileName = AsyncStorage.getItem(AsyncStorageKeys.profileName);
			setIsLoggedIn(true);
			updateDevice(profileName);
			navigationHomeScreen.reset({
				index: 0,
				routes: [
					{
						name: routeHome,
					},
				],
			});
			return;
		}

		navigationProfileNameSelectScreen.navigate(routeProfileNameSelect, { location: Pages.main });
	};

	const processLogin = async () => {
		const presignedService = await getPresignedUrl();
		setPresignedUrl(presignedService);
		setIsLogin(true);
		setIsSigninLoading(false);
		pushProfileNameStateToBrowserHistory(ProfileNameState.profileNameSelect);
		setMistakeCount(0);
		AsyncStorage.setItem(AsyncStorageKeys.email, email);
		validateDeviceScreen();
	};

	const loginAccount = async () => {
		setRetryCommand(RetryCommand.Login);
		if (!email || !onEnterEmail(email)) {
			setEmailMessage(globalAny.language.invalid_email);
			return;
		}

		if (!password || !onEnterPassword(password)) {
			setPasswordMessage(globalAny.language.invalid_password);
			setPasswordError(true);
			return;
		}
		setNavigateEvent("");
		setIsSigninLoading(true);

		setLoginEmail(email);
		let initialized = await login(email, password, setIsLoggedIn);

		if (initialized?.proceed) {
			await processLogin();
			return;
		}

		if (initialized !== undefined) {
			onErrorSignIn(initialized?.response);
		}
	};

	const handleKeyPress = ({ nativeEvent: { key: keyValue } }: any) => {
		if (keyValue === "Enter") {
			setIsSigninLoading(false);
			loginAccount();
		}
	};

	const onClose = () => {
		navigationLoginScreen.navigate(routeLogin, {});
	};

	const onPrivacy = () => {
		navigation.push(routePrivacyPolicy);
	};

	/**
	 * Renders the full-screen sign-in form UI.
	 *
	 * This component includes:
	 * - Email and password input fields with validation and error handling.
	 * - Buttons for recovering password and signing in.
	 * - A privacy policy button.
	 *
	 * @returns {JSX.Element} The full-screen sign-in form layout.
	 */
	const renderSignInFullScreen = () => {
		return (
			<>
				{/* @ts-ignore */}
				<StyledWrapper>
					{/* @ts-ignore */}
					<StyledFormContainer>
						<TextInput
							componentTheme={ComponentThemeType.VinFast}
							onChangeText={(e) => setEmail(e)}
							placeholder={globalAny.language.email_placeholder}
							label={globalAny.language.enter_email_ca}
							error={emailError}
							errorMessage={emailMessage}
							autoFocus={true}
							disabled={isSigninLoading}
							hasValue={hasValue(email)}
						/>
						<TextInput
							componentTheme={ComponentThemeType.VinFast}
							label={globalAny.language.enter_password}
							onChangeText={(e) => setPassword(e)}
							onPressInputIcon={() => onPressEye()}
							inputIcon={secureTextEntry ? Icon.eye : Icon.eyeOff}
							passwordField={secureTextEntry}
							error={passwordError}
							errorMessage={passwordMessage}
							autoFocus={autoFocusPass}
							onKeyPress={handleKeyPress}
							disabled={isSigninLoading}
							hasValue={hasValue(password)}
						/>
					</StyledFormContainer>
				</StyledWrapper>
				{/* @ts-ignore */}
				<StyledButtonContainer>
					{/* @ts-ignore */}
					<StyledButtonMainContainer>
						<TouchableButton
							componentTheme={ComponentThemeType.VinFast}
							type={ComponentTypeEnum.Secondary}
							onPress={() => RecoverPassword()}
							disabled={isSigninLoading}
						>
							{globalAny.language.recover_password}
						</TouchableButton>
						<TouchableButton
							componentTheme={ComponentThemeType.VinFast}
							type={ComponentTypeEnum.Primary}
							onPress={() => {
								loginAccount();
							}}
						>
							{globalAny.language.sign_in}
						</TouchableButton>
					</StyledButtonMainContainer>
					<PrivacyPolicyButton onPress={onPrivacy} />
				</StyledButtonContainer>
			</>
		);
	};

	/**
	 * Renders the Narrow-screen sign-in form UI.
	 *
	 * This component includes:
	 * - Email and password input fields with validation and error handling.
	 * - Buttons for recovering password and signing in.
	 * - A privacy policy button.
	 *
	 * @returns {JSX.Element} The Narrow-screen sign-in form layout.
	 */
	const renderSignInNarrowScreen = () => {
		return (
			<>
				{/* @ts-ignore */}
				<NarrowScreenContainer>
					{/* @ts-ignore */}
					<StyledNarrowButtonsContainer>
						{/* @ts-ignore */}
						<StyledNarrowButtonsWrapper>
							<TouchableButton
								componentTheme={ComponentThemeType.VinFast}
								type={ComponentTypeEnum.Primary}
								onPress={() => {
									loginAccount();
								}}
								leftText
							>
								{globalAny.language.sign_in}
							</TouchableButton>
							<TouchableButton
								componentTheme={ComponentThemeType.VinFast}
								type={ComponentTypeEnum.Secondary}
								onPress={() => RecoverPassword()}
								disabled={isSigninLoading}
								leftText
							>
								{globalAny.language.recover_password}
							</TouchableButton>
						</StyledNarrowButtonsWrapper>
						<PrivacyPolicyButton onPress={onPrivacy} />
					</StyledNarrowButtonsContainer>
					{/* @ts-ignore */}
					<StyledNarrowTextInput>
						{/* @ts-ignore */}
						<StyledNarrowTextContainer isGap={!emailError}>
							<TextInput
								componentTheme={ComponentThemeType.VinFast}
								onChangeText={(e) => setEmail(e)}
								placeholder={globalAny.language.email_placeholder}
								label={globalAny.language.enter_email_ca}
								error={emailError}
								errorMessage={emailMessage}
								autoFocus={true}
								disabled={isSigninLoading}
								hasValue={hasValue(email)}
								isHideError={!emailError}
							/>
							<TextInput
								componentTheme={ComponentThemeType.VinFast}
								label={globalAny.language.enter_password}
								onChangeText={(e) => setPassword(e)}
								onPressInputIcon={() => onPressEye()}
								inputIcon={secureTextEntry ? Icon.eye : Icon.eyeOff}
								passwordField={secureTextEntry}
								error={passwordError}
								errorMessage={passwordMessage}
								autoFocus={autoFocusPass}
								onKeyPress={handleKeyPress}
								disabled={isSigninLoading}
								hasValue={hasValue(password)}
							/>
						</StyledNarrowTextContainer>
					</StyledNarrowTextInput>
				</NarrowScreenContainer>
			</>
		);
	};

	/**
	 * Redirects to the Home screen by resetting the navigation stack
	 * when the user is logged in and a profile name exists.
	 */
	useEffect(() => {
		if (isLoggedIn && globalAny.profileName) {
			navigationHomeScreen.reset({
				index: 0,
				routes: [
					{
						name: routeHome,
					},
				],
			});
		}
	}, [isLoggedIn, globalAny.profileName]);

	/**
	 * Re-validates the mistake count whenever the sign-in loading state changes.
	 */
	useEffect(() => {
		validateMistakeCount();
	}, [signInLoading]);

	/**
	 * Triggers the sign-in loading state for 1 second on component mount.
	 */
	useEffect(() => {
		setSignInLoading(true);
		setTimeout(() => {
			setSignInLoading(false);
		}, 1000);
	}, []);

	useRetryCommand(RetryCommand.Login, loginAccount);

	if (signInLoading) {
		return <SignInLoader />;
	}

	return (
		<SafeAreaView style={{ flex: 1, backgroundColor: light_black, height: "100%" }}>
			<TopAppBar
				leftIcon={closeIcon}
				leftIconWidth={92}
				leftTitleIcon={backIcon}
				screenTitle={capitalize(globalAny.language.sign_in)}
				onPressLeftTitleIcon={onBackPress}
				onPressLeftIcon={onClose}
				isSingleLogo={true}
				isNarrow={isNarrow}
			/>

			{isNarrow ? renderSignInNarrowScreen() : renderSignInFullScreen()}

			{visible ? <Toast visible={visible} text={toastMessage} label={labelText} onDismissSnackBar={onDismissSnackBar} /> : <></>}
		</SafeAreaView>
	);
};

export default SignInScreen;
